import type { CartItem } from '~/types/models/cart.model'

export function getItemsCount(items: CartItem[]): number {
  return items.reduce((acc, item) => acc + item.quantity, 0)
}
